export default "__VITE_ASSET__CCY5z9eW__"